import globalHook from "use-global-hook";
import React from "react";

export const defaultAnswers = {
    store: "",
    associateName: "",
    symptomsYesNo: null,
    contactYesNo: null,
    lastTimeInStore: null,
    listOfPeopleInContact: ""
}

const initialState = {
    answers: defaultAnswers,
};

const actions = {
    updateState: (store, name, value) => {
        //console.log("PrevStore :" + JSON.stringify(store) + "," + name + "," + value)
        const newState = {...store.state, answers: {
            ...store.state.answers, [name]: value}
        };
        //console.log("NewStore :" + JSON.stringify(newState) + "," + name + "," + value)
        store.setState(newState);
    },
    resetState: (store) => {
        store.setState(initialState)
    }
}

const useGlobal = globalHook(React, initialState, actions);

export default useGlobal;
